import { Check } from "lucide-react";

/**
 * Build My Own Deal — persistent progress bar.
 *
 * Always visible at the top of the wizard. Shows all 9 step labels with
 * the current step highlighted and completed steps marked. On mobile the
 * full label set is horizontally scrollable so the design stays clean.
 */
export default function ByodProgressBar({ steps, currentIdx, onStepClick, completedKeys }) {
  return (
    <nav
      className="ssc-byod-progress sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-[var(--ssc-line)]"
      aria-label="Build My Own Deal progress"
      data-testid="byod-progress"
    >
      <ol className="flex gap-1 sm:gap-2 overflow-x-auto px-3 sm:px-5 py-2 sm:py-3 max-w-5xl mx-auto">
        {steps.map((step, i) => {
          const isCurrent = i === currentIdx;
          const isComplete = completedKeys?.has(step.key);
          const isPast = i < currentIdx;
          const clickable = isPast || isComplete;
          return (
            <li key={step.key} className="flex items-center shrink-0">
              <button
                type="button"
                onClick={clickable && onStepClick ? () => onStepClick(i) : undefined}
                disabled={!clickable}
                className={`flex items-center gap-1.5 px-2 sm:px-3 py-1.5 rounded-full text-[11px] sm:text-xs font-extrabold tracking-wide whitespace-nowrap transition-colors ${
                  isCurrent
                    ? "bg-[var(--ssc-navy)] text-white"
                    : isComplete || isPast
                    ? "bg-[var(--ssc-blue)]/10 text-[var(--ssc-blue)] hover:bg-[var(--ssc-blue)]/15"
                    : "text-[var(--ssc-ink-2)]"
                } ${clickable ? "cursor-pointer" : "cursor-default"}`}
                data-testid={`byod-progress-step-${step.key}`}
                aria-current={isCurrent ? "step" : undefined}
              >
                <span className={`grid place-items-center w-5 h-5 rounded-full text-[10px] ${
                  isCurrent ? "bg-white text-[var(--ssc-navy)]"
                  : isComplete || isPast ? "bg-[var(--ssc-blue)] text-white"
                  : "bg-[var(--ssc-silver-2)] text-[var(--ssc-ink-2)]"
                }`}>
                  {isComplete || isPast ? <Check size={11} strokeWidth={3} /> : i + 1}
                </span>
                <span className="hidden sm:inline">{step.label}</span>
                <span className="sm:hidden">{step.label}</span>
              </button>
              {i < steps.length - 1 && (
                <span className="mx-0.5 sm:mx-1 text-[var(--ssc-line)]" aria-hidden>·</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
